<app-loader></app-loader>
<section class="listing-hero-section hidden-section" data-scrollax-parent="true" id="sec1">
    <div class="bg-parallax-wrap">
        <div class="bg par-elem" [ngStyle]="{'background-image':'url('+profileBgImageURL+')'}" data-scrollax="properties: { translateY: '30%' }"></div>
    </div>
    <div class="container">
        <div class="list-single-header-item  fl-wrap">
            <div class="row">
                <div class="col-md-9">
                    <h1>{{businessInfo.businessName}} <span class="verified-badge"><i class="fal fa-check"></i></span></h1>
                    <div class="geodir-category-location fl-wrap">
                        <a href="javascript:void(0);"><i class="fas fa-map-marker-alt"></i> 
                            {{businessInfo.detailAddress}}
                        </a><br><br>
                        <a href="javascript:void(0);"> <i class="fal fa-phone"></i>{{businessInfo.phoneNumber | hide:'phone':5}}</a> <br>
                        <div class="clearfix"></div>
                        <a href="javascript:void(0);"><i class="fal fa-envelope"></i> {{businessInfo.businessWebsite | hide:'email':5}}</a>
                    </div>
                    <input type="hidden" value="{{businessInfo.businessKeywords}}">
                </div>
                <div class="col-md-3">
                    <div class="geodir-js-favorite_btn qrcode">
                        <a *ngIf="isBrowser" [href]="qrCodeDownloadLink" download="qrcode" title="Download QR & Share profile">
                            <qrcode [qrdata]='qrCodeString()' (qrCodeURL)="onChangeURL($event)" [width]="125" height="125" [errorCorrectionLevel]="'M'"></qrcode>
                        </a>
                    </div>
                    <a class="fl-wrap list-single-header-column custom-scroll-link " href="javascript:void(0)">
                        <div class="listing-rating-count-wrap single-list-count">
                            <div class="review-score">{{feedAvg | number:'1.1-1'}}</div>
                            <div class="listing-rating">
                            <app-star-rating [rating]='feedAvg' [readonly]="true"></app-star-rating>
                            </div>
                            <br>
                            <div class="reviews-count">{{feedTotal}} reviews</div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
        <div class="list-single-header_bottom fl-wrap">
            <a class="listing-item-category-wrap" href="javaScript:void(0);">
                <div class="listing-item-category red-bg"><i class="fal fa-tree-alt"></i></div>
                <span> {{businessInfo.categoryInfoId}}</span>
            </a>
            <div class="list-single-author"> <a href="javaScript:void(0);"><span class="author_avatar"> <img alt='{{businessInfo.firstName}} {{businessInfo.lastName}}' src='{{profileImageURL}}'>  </span>By  {{businessInfo.firstName}} {{businessInfo.lastName}}</a></div>
            <div class="geodir_status_date gsd_open"><i class="fal fa-lock-open"></i>Open Now</div>
            <div class="list-single-stats">
                <ul class="no-list-style">
                    <li><span class="viewed-counter"><i class="fas fa-eye"></i> Viewed -  {{watchers}} </span></li>
                    <li class="hide"><span class="bookmark-counter"><i class="fas fa-heart"></i> Bookmark -  24 </span></li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- scroll-nav-wrapper-->
<div class="scroll-nav-wrapper fl-wrap">
    <div class="container">
        <nav class="scroll-nav scroll-init">
            <ul class="no-list-style">
                <li><a class="act-scrlink" href="javascript:void(0);"><i class="fal fa-images"></i> Top</a></li>
                <li><a href="javascript:void(0);"><i class="fal fa-info"></i>Details</a></li>
                <li><a href="javascript:void(0);"><i class="fal fa-image"></i>Gallery</a></li>
                <li><a href="javascript:void(0);"><i class="fa fa-shopping-cart"></i>Products</a></li>
                <li><a href="javascript:void(0);"><i class="fal fa-comments-alt"></i>Reviews</a></li>
            </ul>
        </nav>
        <div class="scroll-nav-wrapper-opt">
            <a href="javascript:void(0);" class="scroll-nav-wrapper-opt-btn"> <i class="fas fa-heart"></i> Save </a>
            <a href="javascript:void(0);" class="scroll-nav-wrapper-opt-btn showshare"> <i class="fas fa-share"></i> Share </a>
            <div class="share-holder hid-share">
                <div class="share-container  isShare"></div>
            </div>
            <div class="show-more-snopt"><i class="fal fa-ellipsis-h"></i></div>
            <div class="show-more-snopt-tooltip">
                <a href="javascript:void(0);"> <i class="fas fa-comment-alt"></i> Write a review</a>
                <a href="javascript:void(0);"> <i class="fas fa-flag-alt"></i> Report </a>
            </div>
        </div>
    </div>
</div>
<!-- scroll-nav-wrapper end-->
<section class="gray-bg no-top-padding">
    <div class="container">
        <div class="breadcrumbs inline-breadcrumbs fl-wrap">
            <a href="/">Home</a><a href="business">Business</a><span>{{businessInfo.businessName}}</span>
        </div>
        <div class="clearfix"></div>
        <div class="row">
            <!-- list-single-main-wrapper-col -->
            <div class="col-md-8">
                <!-- list-single-main-wrapper -->
                <div class="list-single-main-wrapper fl-wrap" id="sec2">
                    <!-- list-single-main-item -->
                    <div class="list-single-main-item fl-wrap block_box">
                        <div class="list-single-main-item-title">
                            <h3>Description</h3>
                        </div>
                        <div class="list-single-main-item_content fl-wrap">
                            <p>{{businessInfo.aboutBusiness}} </p>
                            <p>{{businessInfo.businessDetails}}</p>
                        </div>
                    </div>
                    <!-- list-single-main-item end -->
                    <!-- list-single-main-item-->
                    <div class="list-single-main-item fl-wrap block_box" id="sec3">
                        <div class="list-single-main-item-title">
                            <h3>Gallery / Photos</h3>
                        </div>
                        <div class="list-single-main-item_content fl-wrap">
                            <div class="swiper mySwiper">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" style="height: 400px;" *ngFor="let item of sliderImages?.data">
                                        <img [src]="[serverImgUrl] + '/sliderImages/' + [item.businessImageURL] || '../../assets/images/all/1.jpg'" alt="{{businessInfo.businessName}}">
                                    </div>
                                </div>
                                <div class="swiper-button-next"></div>
                                <div class="swiper-button-prev"></div>
                            </div>
                        </div>
                    </div>
                    <!-- list-single-main-item end -->

                    <!-- list-single-main-item-->
                    <div class="list-single-main-item fl-wrap block_box" id="sec4">
                        <div class="list-single-main-item-title">
                            <h3>List of Business Products Item</h3>
                        </div>
                        <div class="list-single-main-item_content fl-wrap">
                            <div class="pro-item-widget fl-wrap">
                                <app-extra-products></app-extra-products>
                            </div>
                            <a href="#" class="btn-secondary btn pull-right hide">Download PDF<i class="fal fa-file-pdf"></i></a>
                            <a href="products" class="btn-primary btn"> More Products <i class="fa fa-shopping-cart"></i> </a>
                        </div>
                    </div>
                    <!-- list-single-main-item end -->

                    <!-- list-single-main-item -->
                    <div class="list-single-main-item fl-wrap block_box">
                        <div class="list-single-main-item-title">
                            <h3>Listing Features</h3>
                        </div>
                        <div class="list-single-main-item_content fl-wrap">
                            <div class="listing-features fl-wrap">
                                <ul class="no-list-style">
                                    <li><a href="javascript:void(0);"><i class="fa fa-rocket"></i> Quality Product</a></li>
                                    <li><a href="javascript:void(0);"><i class="fa fa-globe-europe"></i> Free Packing</a></li>
                                    <li><a href="javascript:void(0);"><i class="fa fa-shopping-cart"></i> Online Ordering</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- list-single-main-item end -->

                    <div class="list-single-main-media fl-wrap d-none">
                        <img src="../../assets/images/all/1.jpg" class="respimg" alt="Business profile" loading="lazy" decoding="async">
                        <a href="https://vimeo.com/70851162" class="promo-link image-popup"><i class="fal fa-video"></i><span>Promo Video</span></a>
                    </div>

                    <!-- list-single-main-item -->
                    <app-review></app-review>
                    <!-- list-single-main-item end -->
                </div>
            </div>
            <!-- list-single-main-wrapper-col end -->
            <!-- list-single-sidebar -->
            <div class="col-md-4">
                <!--box-widget-item -->
                <div class="box-widget-item fl-wrap block_box">
                    <div class="box-widget-item-header">
                        <h3>Send Enquiry</h3>
                    </div>
                    <div class="box-widget">
                        <div class="box-widget-content">
                            <app-send-enquiry></app-send-enquiry> 
                        </div>
                    </div>
                </div>
                <!--box-widget-item end -->
                <!--box-widget-item -->
                <div class="box-widget-item fl-wrap block_box">
                    <div class="box-widget-item-header">
                        <h3>Location / Contacts </h3>
                    </div>
                    <div class="box-widget">
                        <app-location-details [userInfoId]="userInfoId"></app-location-details>
                    </div>
                </div>
                <!--box-widget-item end -->  

                <!--box-widget-item -->
                <div class="box-widget-item fl-wrap block_box">
                    <div class="box-widget-item-header">
                        <h3>Premium Advertiser</h3>
                    </div>
                    <div class="box-widget opening-hours fl-wrap">
                        <div class="box-widget-content">
                            <app-premium-ads></app-premium-ads>
                        </div>
                    </div>
                </div>
                <!--box-widget-item end -->

                <!-- list-single-facts -->
                <div class="list-single-facts fl-wrap">
                    <div class="row">
                        <div class="col-md-6">
                            <!-- inline-facts -->
                            <div class="inline-facts-wrap gradient-bg ">
                                <div class="inline-facts">
                                    <i class="fal fa-smile-plus"></i>
                                    <div class="milestone-counter">
                                        <div class="stats animaper">
                                            <div class="num" data-content="0" data-num="245">0</div>
                                        </div>
                                    </div>
                                    <h6>New Visiters Every Week</h6>
                                </div>
                                <div class="stat-wave">
                                    <svg viewbox="0 0 100 25">
                                                <path fill="#fff" d="M0 30 V12 Q30 17 55 2 T100 11 V30z" />
                                            </svg>
                                </div>
                            </div>
                            <!-- inline-facts end -->
                        </div>
                        <div class="col-md-6">
                            <!-- inline-facts  -->
                            <div class="inline-facts-wrap gradient-bg ">
                                <div class="inline-facts">
                                    <i class="fal fa-users"></i>
                                    <div class="milestone-counter">
                                        <div class="stats animaper">
                                            <div class="num" data-content="0" data-num="2557">0</div>
                                        </div>
                                    </div>
                                    <h6>Happy customers every year</h6>
                                </div>
                                <div class="stat-wave">
                                    <svg viewbox="0 0 100 25">
                                                <path fill="#fff" d="M0 30 V12 Q30 17 55 12 T100 11 V30z" />
                                            </svg>
                                </div>
                            </div>
                            <!-- inline-facts end -->
                        </div>
                    </div>
                </div>
                <!-- list-single-facts end -->
                 
                <!--box-widget-item -->
                <app-working-details></app-working-details>  
                <!--box-widget-item end -->
            </div>
            <!-- list-single-sidebar end -->
        </div>
    </div>
</section>
<div class="limit-box fl-wrap"></div>